import {defineMessages} from 'react-intl';
import {useCallback} from 'react';

import {FullDrawerConfirmation} from '@stripe-internal/conversations-ui';

import {
  useApp,
  useSetAppState,
  useShowCloseConfirmation,
} from '../hooks/appHooks';

const messages = defineMessages({
  title: {
    id: 'conversations_assistant.closeConfirmation.title',
    description: 'Title when user intends to close the chat window',
    defaultMessage: 'This will end your conversation.',
  },
  description: {
    id: 'conversations_assistant.closeConfirmation.description',
    description:
      'Description provided when user intends to close the chat window',
    defaultMessage: 'Are you sure you want to exit?',
  },
  confirm: {
    id: 'conversations_assistant.closeConfirmation.confirm',
    description:
      'Text shown for the close chat button when closing the chat window',
    defaultMessage: 'Yes, end chat',
  },
  cancel: {
    id: 'conversations_assistant.closeConfirmation.cancel',
    description:
      'Text shown for the cancel button when canceling closing the chat window',
    defaultMessage: 'No, keep chatting',
  },
});

export function CloseConfirmationModal() {
  const app = useApp();
  const showCloseConfirmation = useShowCloseConfirmation();
  const setAppState = useSetAppState();

  // if a custom onClose handler used handles the onClose callback,
  // the default close confirmation behavior will be skipped
  const cancelClose = useCallback(() => {
    setAppState((state) => {
      state.showCloseConfirmation = false;
    });
  }, [setAppState]);

  // if a custom onClose handler used handles the onClose callback,
  // the default close confirmation behavior will be skipped
  const confirmClose = useCallback(() => {
    app.close(true);
  }, [app]);

  if (!showCloseConfirmation) {
    return null;
  }

  return (
    <FullDrawerConfirmation
      open
      title={messages.title}
      description={messages.description}
      confirmLabel={messages.confirm}
      cancelLabel={messages.cancel}
      onConfirm={confirmClose}
      onCancel={cancelClose}
    />
  );
}
